import {
	EnrollmentResponse,
	RequestBody,
	requestStatus,
	ResponseData,
} from './connector';

export default abstract class AbstractConnector {
	protected request: RequestBody | null = null;
	protected requestStatus: requestStatus = requestStatus.INACTIVE;
	private callback: Function = () => {};
	private response: ResponseData[] = [];
	private timeout: NodeJS.Timeout | undefined;
	private time: number = 0;

	protected abstract prepareRequest(input: RequestBody): Promise<void>;
	protected abstract sendRequest(): Promise<object>;
	protected abstract checkResponse(response: object): boolean;
	protected abstract parseResponse(response: object): ResponseData[];
	protected abstract wrapRequest(): void;

	public async enroll(
		input: RequestBody,
		callback: (a: EnrollmentResponse) => void
	): Promise<void> {
		this.request = input;
		this.requestStatus = requestStatus.INPROGRESS;
		this.callback = callback;
		try {
			this.setTimeout();
			await this.prepareRequest(input);
			console.time('enrollmentRequest');
			const response = await this.sendRequest();
			console.timeEnd('enrollmentRequest');
			this.handleResponse(response);
		} catch (err) {
			console.error('Connector error', err);
			this.requestStatus = requestStatus.ERROR;
			this.runCallback();
		}
	}

	protected handleResponse(response: object) {
		console.log('Handling response');
		try {
			if (this.checkResponse(response)) {
				this.response = this.parseResponse(response);
				this.requestStatus = requestStatus.COMPLETED;
				this.runCallback();
			}
		} catch (err) {
			console.error('Error handling response', err);
			this.requestStatus = requestStatus.ERROR;
			this.runCallback();
		}
	}

	private runCallback() {
		clearTimeout(this.timeout);
		try {
			this.callback &&
				this.callback({
					status: this.requestStatus,
					data: this.response,
					time: new Date().getTime() - this.time,
					patientId: this.response[0]?.patientId,
				});
			this.wrapRequest();
		} catch (err) {
			console.error('Error ending request', err);
		}
	}

	private onTimeout() {
		if (this.requestStatus === requestStatus.INPROGRESS) {
			console.log('Request timeout');
			this.requestStatus = requestStatus.TIMEOUT;
			this.runCallback();
		}
	}

	private readonly setTimeout = () => {
		this.time = new Date().getTime();
		if (this.timeout) {
			clearTimeout(this.timeout);
		}
		console.debug(
			'Request timeout set to: ',
			process.env.GATSBY_SUBSCRIPTION_TIMEOUT
		);
		this.timeout = setTimeout(
			() => this.onTimeout(),
			parseInt(process.env.GATSBY_SUBSCRIPTION_TIMEOUT as string)
		);
	};
}
